module.exports = __webpack_public_path__ + "static/img/new_raw_1523956664.3b1dbeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_raw_1523956664.jpg
// module id = hE//
// module chunks = 1